import React from 'react'
import styled from '@emotion/styled'
import MUIListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon'

import variables from 'assets/styles/scss/shared/_variables.module.scss'

interface StyledListItemIconProps extends ListItemIconProps {
  selected?: boolean
}

const setColor = (props: StyledListItemIconProps) => {
  if (props.selected) return variables['blue']
}

const StyledListItemIcon = styled(MUIListItemIcon)`
  color: ${(props: StyledListItemIconProps) => setColor(props)};
  min-width: 3rem;
`
const ListItemIcon = (props: StyledListItemIconProps) => {
  return <StyledListItemIcon {...props} />
}

export default ListItemIcon
